import 'apps/pathways/styles/components/result-modal.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { Link } from 'library/util/core-router';
import { format_number } from 'library/helpers/numbers';
import { capitalize } from 'library/helpers/text';
import HawtSvg from 'apps/pathways/icons/hawt.svg';
import LocationMarker from 'library/components/location-marker';
import DataPartnerBanner from 'library/components/data-partner';
import withConfig from 'util/hoc/with-config';

const EDUCATION_DESCRIPTIONS = {
  "High School or Equivalent": "Includes High School Diploma, GED, or other equivalent education.  The high school diploma is typically studied for over the course of four years, requiring a combination of selected coursework meeting specified criteria for a particular stream and acceptable passing grades earned on the state exit examination.",
  "Associate's Degree": "An undergraduate academic degree awarded by colleges and universities upon completion of a course of study intended to usually last two years. It is considered to be greater level of education than a high school diploma or GED.",
  "Bachelor's Degree": "An undergraduate academic degree awarded by colleges and universities upon completion of a course of study lasting three to seven years (depending on institution and academic discipline).",
  "Master's Degree": "A second-cycle academic degree awarded by universities or colleges upon completion of a course of study demonstrating mastery or a high-order overview of a specific field of study or area of professional practice.",
  "Doctoral Degree": "The highest level of academic degree, a doctorate is an academic degree awarded by universities that is a research degree that qualifies the holder to teach at the university level in the degree's field, or to work in a specific profession.",
  "Certificate Programs": "A certification is a third-party attestation of an individual's level of knowledge or proficiency in a certain industry or profession. Many certification programs are affiliated with professional associations, trade organizations, or private vendors interested in raising industry standards."
}

class ResultModal extends React.PureComponent {
  componentWillMount() {
    document.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  handleClick = (e) => {
    if (e.target === this.refs.inner.parentElement) {
      e.preventDefault();
      e.stopPropagation();

      this.props.close();
    }
  }

  get opportunity_score() {
    const { opportunity=80 } = this.props.result;
    if (opportunity < 38) {
      return 'POOR'
    } else if (opportunity < 54) {
      return 'FAIR'
    } else if (opportunity < 74) {
      return 'GOOD'
    }
    return 'GREAT'
  }

  renderMedianAnnual = (wage) => {
    const aggregate_types = ['median', 'mean'];
    const aggregate_frequency = ['annual', 'hourly'];

    if (wage) {
      for (const type of aggregate_types) {
        for (const frequency of aggregate_frequency) {
          if (wage[`${type}_${frequency}_rate`]) {
            return (
              <div className="result-modal-stat">
                ${ format_number(wage[`${type}_${frequency}_rate`]) }
                <small>{capitalize(type)} {capitalize(frequency)}</small>
              </div>
            )
          }
        }
      }
    }

    return (
      <div className="result-modal-stat">
        No Data
        <small>Median Annual</small>
      </div>
    )
  }

  renderEmployment = (employment) => {
    if (employment && employment.projected_employment) {
      return (
        <div className="result-modal-stat">
          {`${Number((employment.projected_employment||0) * 100).toFixed(1)}%`}
          <small>Projected Growth</small>
        </div>
      )
    }

    return (
      <div className="result-modal-stat">
        No Data
        <small>Projected Growth</small>
      </div>
    );
  }

  renderTotalEmployment = (employment) => {
    if (employment && employment.total_employed) {
      return (
        <div className="result-modal-stat">
          { format_number(employment.total_employed) }
          <small>Number of Jobs</small>
        </div>
      )
    }
    return (
      <div className="result-modal-stat">
        No Data
        <small>Number of Jobs</small>
      </div>
    );
  }

  renderEducation = (education) => {
    if (!education) return null;

    return (
      <div className="result-modal-body">
        <div className="result-modal-education">
          <i className="icon-education" />
          <p>
            <span><strong>{ education.minimum_requirement }</strong></span>
            <span>recommended</span>
          </p>
        </div>
        <div>
          <h2>Education Requirements</h2>
          <p dangerouslySetInnerHTML={{__html: EDUCATION_DESCRIPTIONS[education.minimum_requirement]}} />
        </div>
      </div>
    )
  }

  renderHawt = () => {
    if (this.props.result.hawt) {
      return (
        <span className="result-modal-header-hawt" data-tooltip="Hot Careers are careers that will be a great field to enter into due to a mixture of demand in the field & a good salary." data-tooltip-position="bottom">
          <HawtSvg style={{width: '100px', height: '100px'}} />
        </span>
      );
    }
    return null;
  }

  renderLocation = (location) => {
    if (!location) return null;

    return (
      <LocationMarker>
        {location.title} Data
      </LocationMarker>
    );
  }

  render() {
    const {
      result = {},
      close = ()=>{},
      withPathway
    } = this.props;

    const { description, title, wage, employment, education, location } = result;

    return (
      <div ref="inner" className="result-modal-inner">
        <h1 className="result-modal-header">
          <span>{ title }</span>
          <a href="javascript:void(0)" onClick={close}>×</a>
        </h1>
        <div className="result-modal-body">
          <div />
          <div className="result-modal-score">
            { this.opportunity_score } { this.renderHawt() }
            <small>opportunity</small>
          </div>
          <div />
        </div>
        <div className="result-modal-body">
          { this.renderLocation(location) }
        </div>
        <div className="result-modal-body">
          { this.renderMedianAnnual(wage) }
          { this.renderEmployment(employment) }
          { this.renderTotalEmployment(employment) }
        </div>
        <hr />
        <div className="result-modal-body">
          <div>
            <h2>What they do</h2>
            <p dangerouslySetInnerHTML={{__html: description}} />
          </div>
        </div>
        { this.renderEducation(education) }
        <div className="result-modal-footer">
          {
            withPathway
              ? (
                <button onClick={this.props.start}>Get Started</button>
              )
              : null
          }
        </div>
        <DataPartnerBanner partners={['burning-glass']} />
      </div>
    );
  }
}

export default ResultModal;
